const productTypesData = {
  business_card: {
    route: 'business-cards',
    sizes: [
      {
        id: 'businesscard',
        route: 'moo-business-card',
      },
      {
        id: 'businesscard_square',
        route: 'square-business-card',
      },
      {
        id: 'businesscard_us',
        route: 'standard-business-card',
      },
      {
        id: 'minicard',
        route: 'original-minicard',
      },
    ],
  },
  postcard: {
    route: 'postcards',
    sizes: [
      {
        id: 'postcard',
        route: 'original-postcard',
      },
      {
        id: 'postcard_standard',
        route: 'standard-postcard',
      },
      {
        id: 'postcard_square',
        route: 'square-postcard',
      },
      {
        id: 'postcard_dl_us',
        route: 'rack-card',
      },
      {
        id: 'postcard_dl',
        route: 'dl-postcard',
      },
      {
        id: 'postcard_medium',
        route: 'medium-postcard',
      },
      {
        id: 'postcard_half_page_us',
        route: 'half-page-postcard',
      },
      {
        id: 'postcard_large',
        route: 'large-postcard',
      },
      {
        id: 'postcard_a5',
        route: 'a5-postcard',
      },
    ],
  },
  letterhead: {
    route: 'letterheads',
    sizes: [
      {
        id: 'letterhead_a4',
        route: 'moo-letterhead',
      },
      {
        id: 'letterhead_us_letter',
        route: 'standard-letterhead',
      },
    ],
  },
  notecard: {
    route: 'notecards',
    sizes: [
      {
        id: 'notecard',
        route: 'original-notecard',
      },
    ],
  },
  sticker: {
    route: 'stickers',
    sizes: [
      {
        id: 'sticker',
        route: 'stickerbook',
      },
      {
        id: 'sticker_round',
        route: 'round-sticker',
      },
      {
        id: 'sticker_label',
        route: 'rectangular-sticker',
      },
      {
        id: 'return_address_labels',
        route: 'return-address-label',
      },
      {
        id: 'sticker_large_round',
        route: 'large-round-sticker',
      },
      {
        id: 'sticker_large_rectangular',
        route: 'large-rectangular-sticker',
      },
    ],
  },
  flyer: {
    route: 'flyers',
    sizes: [
      {
        id: 'flyer_a4',
        route: 'a4-flyer',
      },
      {
        id: 'flyer_dl',
        route: 'dl-flyer',
      },
      {
        id: 'flyer_a5',
        route: 'a5-flyer',
      },
      {
        id: 'flyer_a6',
        route: 'a6-flyer',
      },
      {
        id: 'flyer_square',
        route: 'square-flyer',
      },
      {
        id: 'flyer_half_page_us',
        route: 'half-page-flyer',
      },
      {
        id: 'flyer_us_letter',
        route: 'letter-flyer',
      },
      {
        id: 'flyer_dl_us',
        route: 'dl-flyer',
      },
    ],
  },
  holidaycard: {
    route: 'greeting-cards',
    sizes: [
      {
        id: 'holidaycard',
        route: 'original-greeting-card',
      },
    ],
  },
};

export default productTypesData;
